module.exports = __webpack_public_path__ + "static/media/01_Mascotte_normal.4235c03f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/01_Mascotte_normal.svg
// module id = 757
// module chunks = 0